'use client'

import { ThemeProvider } from "@mui/material";
import { generateTheme } from "Context/theme";

export default function Provider({ children }) {
    const theme = generateTheme();
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}